// extracted by mini-css-extract-plugin
export default {"feedbackModal":"FeedbackModal_feedbackModal__gMgzy","textarea":"FeedbackModal_textarea__Gd-qH"};